export default __webpack_public_path__ + "static/media/left-boot-print.fb357ede.png";